import { render, staticRenderFns } from "./GalleryTable.vue?vue&type=template&id=38ababea&"
import script from "./GalleryTable.vue?vue&type=script&lang=js&"
export * from "./GalleryTable.vue?vue&type=script&lang=js&"
import style0 from "./GalleryTable.vue?vue&type=style&index=0&id=38ababea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports